var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.169,
    height: 31.17,
    viewBox: "0 0 31.169 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-3649.693 -1912.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M3680.862,1922.357v17.39a4.421,4.421,0,0,1-4.419,4.42h-22.331a4.421,4.421,0,0,1-4.419-4.42v-22.33a4.421,4.421,0,0,1,4.419-4.42H3671.5Z",
    fill: "#d9091e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M3671.5,1917.937V1913l9.359,9.36h-4.94A4.421,4.421,0,0,1,3671.5,1917.937Z",
    fill: "#e44e56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M3655.83,1926.049h1.85c.233,0,.489.011.767.031a4.379,4.379,0,0,1,.836.15,3.187,3.187,0,0,1,.807.361,2.462,2.462,0,0,1,.689.661,3.4,3.4,0,0,1,.482,1.046,5.531,5.531,0,0,1,.182,1.528v.429a7.237,7.237,0,0,1-.167,1.675,4.353,4.353,0,0,1-.447,1.172,2.644,2.644,0,0,1-.646.76,2.873,2.873,0,0,1-.764.432,3.37,3.37,0,0,1-.8.192,6.465,6.465,0,0,1-.761.047h-.178v3.714h-1.85Zm1.942,7.127a2.138,2.138,0,0,0,.843-.147,1.183,1.183,0,0,0,.546-.457,2.137,2.137,0,0,0,.293-.8,6.605,6.605,0,0,0,.09-1.174v-1.1a4.916,4.916,0,0,0-.079-.939,1.518,1.518,0,0,0-.282-.654,1.208,1.208,0,0,0-.546-.382,2.564,2.564,0,0,0-.865-.125h-.092v5.778Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M3662.844,1926.049h1.92q.437,0,.9.024a4.126,4.126,0,0,1,.914.154,2.95,2.95,0,0,1,.843.4,2.456,2.456,0,0,1,.7.75,4.114,4.114,0,0,1,.476,1.214,7.87,7.87,0,0,1,.174,1.79v3.542a7.912,7.912,0,0,1-.174,1.793,4.073,4.073,0,0,1-.476,1.214,2.464,2.464,0,0,1-.7.746,2.954,2.954,0,0,1-.843.4,4.077,4.077,0,0,1-.914.154q-.468.025-.9.025h-1.92Zm2.32,10.905a2.286,2.286,0,0,0,.826-.128,1.027,1.027,0,0,0,.514-.454,2.363,2.363,0,0,0,.26-.886,11.428,11.428,0,0,0,.072-1.417v-3.786a11.453,11.453,0,0,0-.072-1.417,2.363,2.363,0,0,0-.26-.886,1.031,1.031,0,0,0-.514-.454,2.286,2.286,0,0,0-.826-.128h-.471v9.556Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M3670.421,1926.049h4.664v1.456h-2.814v3.65h2.207v1.457h-2.207v5.635h-1.85Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.777db96e568e3195822015eb3608d818.svg";
export { ForwardRef as ReactComponent };